// extracted by mini-css-extract-plugin
export var fileUpload = "_h2-1";
export var modalButton = "_h2-0";